import React from 'react'
import { EventGQL, TeamGQL } from '../../../../Api'
import {
  getTeamImage,
  SEASON_SEGMENT_NAMES,
  createTeamDynamicLink,
  getTeamRecord,
} from '../../../../Utils'
import { TeamInfoCon, TeamSeed } from '../../styles'
import { Img } from '../../../Image/Img'

type ActionProps = {
  event: EventGQL
  team: TeamGQL
}

export const BoxScoreTeam: React.FC<React.PropsWithChildren<ActionProps>> = ({
  event,
  team,
}) => {
  const createTeamLink = () => {
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.allstar) {
      return `/all-star`
    }
    return createTeamDynamicLink(team)
  }

  const teamImg = getTeamImage(team.fullName, event?.seasonSegment, event?.year)
  const showTeamSeed = () => {
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.post) {
      return team?.seed !== undefined && team?.seed !== null && team?.seed > 0
    }
    return false
  }

  return (
    <TeamInfoCon href={createTeamLink()} aria-label={team?.fullName || createTeamLink()}>
      <div className="logoCon">
        <Img src={teamImg} alt={`${team?.fullName} logo`} />
      </div>
      <div className="nameAndRecordCon">
        <div className="teamNameCon">
          {showTeamSeed() && <TeamSeed>{`${team.seed ?? ''}`}</TeamSeed>}
          <p className="teamName">{team?.locationCode || team.officialId}</p>
        </div>
        <p className="record">
          {event?.eventStatus < 2 &&
            event.seasonSegment !== SEASON_SEGMENT_NAMES.allstar &&
            team &&
            getTeamRecord(team, event.seasonSegment)}
        </p>
      </div>
    </TeamInfoCon>
  )
}
